var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMemeCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V8.25C18 8.66421 17.6642 9 17.25 9C16.8358 9 16.5 8.66421 16.5 8.25V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V21C1.5 21.8284 2.17157 22.5 3 22.5H9.30446C9.71867 22.5 10.0545 22.8358 10.0545 23.25C10.0545 23.6642 9.71867 24 9.30446 24H3C1.34314 24 0 22.6569 0 21V3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.75C4.5 6.33579 4.83579 6 5.25 6H12.75C13.1642 6 13.5 6.33579 13.5 6.75C13.5 7.16421 13.1642 7.5 12.75 7.5H5.25C4.83579 7.5 4.5 7.16421 4.5 6.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75C4.5 9.33579 4.83579 9 5.25 9H11.25C11.6642 9 12 9.33579 12 9.75C12 10.1642 11.6642 10.5 11.25 10.5H5.25C4.83579 10.5 4.5 10.1642 4.5 9.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.75C4.5 12.3358 4.83579 12 5.25 12H8.25C8.66421 12 9 12.3358 9 12.75C9 13.1642 8.66421 13.5 8.25 13.5H5.25C4.83579 13.5 4.5 13.1642 4.5 12.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 24C20.9779 24 24 20.9779 24 17.25C24 13.5221 20.9779 10.5 17.25 10.5C13.5221 10.5 10.5 13.5221 10.5 17.25C10.5 20.9779 13.5221 24 17.25 24ZM17.25 22.5C20.1495 22.5 22.5 20.1495 22.5 17.25C22.5 14.3505 20.1495 12 17.25 12C14.3505 12 12 14.3505 12 17.25C12 20.1495 14.3505 22.5 17.25 22.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.591 15.4017C19.8839 15.1088 20.3588 15.1088 20.6517 15.4017C20.9445 15.6945 20.9445 16.1694 20.6517 16.4623L17.4697 19.6443C17.1768 19.9372 16.7019 19.9372 16.409 19.6443L14.2877 17.523C13.9948 17.2301 13.9948 16.7552 14.2877 16.4623C14.5806 16.1694 15.0555 16.1694 15.3483 16.4623L16.7272 17.8412C16.8444 17.9583 17.0343 17.9583 17.1515 17.8412L19.591 15.4017Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMemeCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/meme-check.56a825654fa693f9bad0c4a60b4a9f0e.svg";